import { VtSettingsListGroupLink } from '@shared/interfaces/settings-list-group-link';
import { TagSettingsRouteName } from '@pages/settings-page/settings-route-names';

export const tagMenuItemTitle = 'Settings.Tag';

export const tagMenuItemLinks: VtSettingsListGroupLink[] = [
  {
    label: 'Settings.Tags.VehicleTags',
    routerLink: TagSettingsRouteName.VehicleTags,
  },
  {
    label: 'Settings.Tags.UserTags',
    routerLink: TagSettingsRouteName.UserTags,
  },
  {
    label: 'Settings.Tags.VehicleProperties',
    routerLink: TagSettingsRouteName.VehicleProperties,
  },
  {
    label: 'Settings.Tags.UserProperties',
    routerLink: TagSettingsRouteName.UserProperties,
  },
  {
    label: 'Settings.Tags.AssetProperties',
    routerLink: TagSettingsRouteName.AssetProperties,
  },
];
